import React from 'react'
import styled from 'styled-components'
import { Grid as BaseGrid } from '@material-ui/core'
import { ChevronLeft as BaseChevronLeft, ExpandMore as BaseExpandMore } from '@material-ui/icons'

export const Root = styled.div`
  box-sizing: border-box;
  padding: 0 0 130px;
  width: 100%;
`

export const DesktopNavigation = styled.div`
  display: flex;

  ${props => props.theme.breakpoints.down('md')} {
    justify-content: center;
  }
`

export const MobileNavigation = styled.div`
  align-items: center;
  background-color: ${props => props.theme.palette.custom.ghostWhite};
  bottom: 0;
  box-shadow: 0 -3px 10px ${props => props.theme.palette.custom.ghostBlack};
  display: flex;
  height: 90px;
  justify-content: center;
  left: 0;
  position: fixed;
  width: 100%;
`

export const Section = styled(({ margin, maxWidth, ...props }) => <BaseGrid {...props} />)`
  margin: ${props => props.margin || 'initial'};
  max-width: ${props => props.maxWidth || 'initial'};

  &.MuiGrid-item {
    margin: ${props => props.margin || 'initial'};
  }
`

export const Title = styled.h1`
  color: ${props => props.theme.palette.custom.mineShaft};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 34px;
  font-weight: 300;
  letter-spacing: 0;
  margin: 0;

  ${props => props.theme.breakpoints.only('xs')} {
    text-align: center;
  }
`

export const Instructions = styled.p`
  color: ${props => props.theme.palette.custom.charcoal};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 22px;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 1.3;
  margin: 0;

  ${props => props.theme.breakpoints.only('xs')} {
    text-align: center;
  }
`

export const AccessInstructions = styled.p`
  color: ${props => props.theme.palette.custom.charcoal};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 16px;
  letter-spacing: 0;
  margin: 0;
`

export const Username = styled.span`
  background-color: ${props => props.theme.palette.green[95]};
  border: 1px solid ${props => props.theme.palette.green[75]};
  color: ${props => props.theme.palette.custom.charcoal};
  display: inline-block;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 24px;
  font-weight: bold;
  letter-spacing: 0;
  margin: 18px 0 36px;
  padding: 6px 60px;
`

export const Strong = styled.span`
  font-weight: bold;
`
export const ItemCollapseIcon = styled(BaseExpandMore)`
  color: ${props => props.theme.palette.brand.black3};
  font-size: 22px;
`
export const ExpandMore = styled(BaseExpandMore)`
  color: ${props => props.theme.palette.brand.black3};
  cursor: pointer;
  font-size: 12px;
`
export const Link = styled.a`
  text-decoration: none;
  color: ${props => props.theme.palette.brand.black3};
  display: flex;
  align-items: center;
`
export const Divided = styled.hr`
  width: ${props => props.width || 'auto'};
  border: 1px solid ${props => props.theme.palette.gray[90]};
  margin: ${props => props.margin};
`
